// Replace laggy JSON.parse with plain eval
// NOTE: on some old LG TVs (e.g. lx761) JSON.parse is really slow for some reason.
try {
  const problematicUserAgents = ['lx761', 'ly750', 'uw761'];
  const ua = navigator.userAgent.toLowerCase();
  if (problematicUserAgents.some((e) => ua.includes(e.toLowerCase()))) {
    JSON.parse = (text: string) => new Function('return ' + text + ';')();
    console.log('[Polyfills] JSON.parse polyfill added.');
  }
} catch (error) {
  console.error('[Polyfills] Unable to polyfill JSON.parse', error);
}
